module.exports = __webpack_public_path__ + "static/media/20000625_1.ee542d80.jpg";